<template>
  <div class="wrapper" :class="{'sidebar-open': isMenuOpened}">
    <navbar
      :isMenuOpen="isMenuOpened"
      @openMenu="isMenuOpened = true"
      @closeMenu="isMenuOpened = false"
    ></navbar>
    <sidebar :nav="$route.meta.sidebar"></sidebar>
    <!--<div class="content-wrapper pt-3">-->
    <div class="content-wrapper d-flex">
      <router-view :key="$route.fullPath"></router-view>
    </div>
  </div>
</template>

<script setup>
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import { ref } from "vue";

let isMenuOpened = ref(false)
</script>

<style>
</style>
